import "./App.css";
import { useDispatch } from "react-redux";
import MainLayoutSupmitter from "./Layout/MainLayoutSupmitter/iindex";
import MainRoutesSupmiter from "./Routes/MainRoutesSupmiter/MainRoutesSupmiter";
import LogInServices from "./Services/Account/LogInServices";
import { SetDataUser } from "./Redux/Reducers/UserInfo";
import { useSelector } from "react-redux";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "./Services/apiService";
import { useEffect, useState } from "react";
import $ from "jquery";
import {
  GetActiveRound,
  GetApplicationInformatio,
} from "./Redux/Reducers/ApplicationInformation";
import LoaderAHSF from "./Components/LoaderAHSF";
import { GetJsonData } from "./Redux/Reducers/FetchDataJson";
import { GetPersonalInformation } from "./Redux/Reducers/PersonalInformation";
import { GetBeneficiaryInformation } from "./Redux/Reducers/BeneficiaryInformation";
import { GetGeneralInformationData } from "./Redux/Reducers/GeneralInformation";
import MainLayoutManager from "./Layout/MainLayoutManager";
import MainRoutsManager from "./Routes/MainRoutsManager/MainRoutsManager";
import LogInManagerServices from "./Services/Account/LogInManagerServices";
import { useCookies } from "react-cookie";
import { SetLogin } from "./Redux/Reducers/Login";
import { useParams } from "react-router-dom";
import { decryptToken } from "./Services/Account/EncryptionParams";
import { GetReportStatusByApplicationGuid } from "./Redux/Reducers/ReportStage/TransferItemInformation";
import { GetRoleByUserGuid } from "./Redux/Reducers/RoleByUser";

function App() {
  const dispatch = useDispatch();
  const refreshTableStatus = useSelector((state) => state.refreshTableStatus);
  const [jsonLoding, setJsonLoding] = useState(false);
  const ApplicationInformationStatus = useSelector(
    (state) => state.ApplicationInformation
  );
  const SubSectorsLoding = useSelector((state) => state.SubSectors);
  const JsonData = useSelector((state) => state.FetchDataJson);
  const loginState = useSelector((state) => state.Login.Login);
  const user = useSelector((state) => state.UserInfo.UserInfo);

  ////////////GetApplicationInformation///////////////////////
  // //console.log(JsonData, "dddsdsdsdsfffffffff");
  const [loginStatus, setLoginStatus] = useState();
  const [cookies, setCookie] = useCookies([]);
  const AppGuid = useParams();
  console.log(JsonData?.JsonData, "kkkkjkjkjkkjkjkjkjjkjkjj");

  useEffect(() => {
    if (
      localStorage.getItem("aI_ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid)
    ) {
      //to get application info by id
      dispatch(
        GetApplicationInformatio(
          localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
        )
      );
      //to get active round id
      dispatch(GetActiveRound());
      dispatch(
        GetReportStatusByApplicationGuid(
          localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid) ||
          localStorage.getItem("aI_ApplicationInformationId_Manager")
        )
      );


    }
  }, [
    refreshTableStatus.refreshApplicationInformation,
    localStorage.getItem("aI_ApplicationInformationId"),
    decryptToken(AppGuid.AppGuid),
    localStorage.getItem("aI_ApplicationInformationId_Manager")
  ]);
  //console.log(AppGuid, "ksjdjksdasdadfkkks");

  /////////////////////////////////////////////////////////
  //////////////////////////////jsonData////////////////////////
  // dispatch(GetJsonData())
  useEffect(() => {
    dispatch(GetJsonData());
  }, []);
  ///////////////////////////////////////////////////////
  //[,]
  //login from sso
  ////////////////logIn////////////
  const logIn = async () => {
    let userInfo = await LogInServices();
    dispatch(SetDataUser(userInfo));
    dispatch(SetLogin(userInfo.login));
    setLoginStatus(userInfo.login);

    //console.log(userInfo, "userInfo");
  };
  ////////////end logIn/////////
  // logIn();
  //[,]
  //login from manager internalsso
  // ----------------- login manager -------------
  const logInManager = async () => {
    console.log("userInfouserInfouserInfo");
    let userInfo = await LogInManagerServices();
    console.log(userInfo, "userInfouserInfouserInfo");
    dispatch(GetRoleByUserGuid(userInfo.userToken.userGuid));

    dispatch(SetDataUser(userInfo));
    dispatch(SetLogin(userInfo.login));
    setLoginStatus(userInfo.login);
    //console.log(userInfo, "userInfo");
  };
  // --------------------------------------------------

  const getJson = async () => {
    var json = await loadConfig();
    if (Object.keys(json).length > 1) {
      setJsonLoding(true);
    }
  };
  useEffect(() => {
    getJson();
  }, []);
  //console.log(JsonData.loadingJsonData, ",a,,a,,a,");
  //[,]
  //if login from manager
  const loginFrom = async () => {
    // if (window.location.pathname == "/grants/manager/") {
    //[,]
    //if login from manager
    if (window.location.href.includes("manager")) {
      logInManager();
      setLoginStatus("manager");
    } else {
      //[,]
      //if login from sso
      if (!cookies.loginTokenSSO) {
        logIn();
        setLoginStatus("sso");
      }
    }
  };
  //console.log(window.location.href.includes("manager"), "window.location.");

  useEffect(() => {
    loginFrom();
  }, []);
  useEffect(() => {
    // show only for submitter
    if (user?.userToken?.userType !== "submitter") return;

    // prevent script from loading twice
    if (document.getElementById("chtl-script")) return;

    // config
    window.chtlConfig = { chatbotId: "8563444195" };

    // script
    const script = document.createElement("script");
    script.id = "chtl-script";
    script.async = true;
    script.type = "text/javascript";
    script.src = "https://chatling.ai/js/embed.js";
    script.setAttribute("data-id", "8563444195");

    document.body.appendChild(script);

    // cleanup (optional – removes chatbot if user changes)
    return () => {
      const existingScript = document.getElementById("chtl-script");
      if (existingScript) {
        existingScript.remove();
      }

      // remove chatbot UI if exists
      const chatWidget = document.querySelector('[id^="chatling"]');
      if (chatWidget) {
        chatWidget.remove();
      }
    };
  }, [user?.userToken?.userType]);
  //to render routs layout by from where user login sso or manager
  return (
    <div className="App">
      <>
        {loginState == "sso" ? (
          !ApplicationInformationStatus.loadingApplicationInformation &&
            JsonData?.JsonData ? (
            <MainLayoutSupmitter>
              <MainRoutesSupmiter />
            </MainLayoutSupmitter>
          ) : (
            <>
              <LoaderAHSF show={true} />
            </>
          )
        ) : (
          ""
        )}

        {loginState == "manager" ? (
          <>
            {
              JsonData?.JsonData ? (
                <>
                  <MainLayoutManager>
                    <MainRoutsManager />
                  </MainLayoutManager>
                </>
              )
                : (<></>)
            }

          </>
        ) : (
          ""
        )}

        {/* <LoaderAHSF show={SubSectorsLoding.
    loadingaI_SecondarySectors}/> */}
      </>
    </div>
  );
}

export default App;
